import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-session-warning-dialog',
  templateUrl: './session-warning-dialog.component.html',
  styleUrls: ['./session-warning-dialog.component.scss']
})
export class SessionWarningDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<SessionWarningDialogComponent>,

  ) {}

  ngOnInit(): void {
  }

  onStay() {
    this.dialogRef.close('extend');
  }

  onLogout() {
    this.dialogRef.close('logout');
  }

}
